export default {
    WarehouseManagement: {
        Header: {
            name: 'Warehouse Name',
            code: 'Warehouse Code',
            status: 'Logical Warehouse Status',
            Add: 'Add Warehouse',
        },
        Main: {
            name: 'Contact Name',
            phone: 'Contact Phone',
            address: 'Warehouse Address',
            warehouse: 'Logical Warehouse Name',
            by: 'Created By',
            time: 'Creation Time',
            Operation: 'Action',
            ps: 'Delete ?',
            ps1: 'Logical warehouse operation, are you sure you want to continue?',
        },
        form: {
            Basic: 'Account Information',
            name: 'Warehouse Name',
            code: 'Warehouse Code',
            Contact: 'Contact Name',
            phone: 'Contact Phone',
            address: 'Warehouse Address',
            Detailed: 'Detailed Address',
            Description: 'Description',
            Bin: 'Logical Warehouse',
            warehouse: 'Logical Warehouse Name',
            Please: 'Please select Country/State',
            enter: 'Please enter detailed address',
            a: 'Please enter warehouse code',
            arehouse: 'Please enter warehouse name',
            ontact: 'Please enter contact name',
            logical: 'Please enter logical warehouse name',
            detail: 'Please enter detailed address.',
            Edit: 'Edit Warehouse',
            Create: 'New Warehouse',
            Saved: 'Saved successfully.',
            postcodeText: 'Please enter Postcode',
            country: 'Country',
            state: 'State',
            city: 'Suburb',
            districtName: 'Area',
            postcode: 'Postcode',
            isLogisticsSpecified: 'Dedicated Courier',
            isPickUp: 'Is Pick Up',
            chooseLogistics: 'Courier Service',
            DefaultMargin: 'Default Margin',
            byPostCode: 'Auto-fill suburb/state/country by Postcode',
            msgErrorText: 'The required information for import is incomplete. Please complete it and re-import',
            if: 'Package Dimensions',
            need: 'Pallet Quantity',
            time: 'Estimated Collection Time',

            isQuotation: 'Confirm Quote',
            status0: 'Not quoted',
            status1: 'Pending',
            status2: 'Confirmed',
            status3: 'Rejected',
            Label: 'Edit Label',
            Quote: 'Input Quote',
            Dimension: 'Input Dimension',
            Shipping: 'Modify Shipping Method',
            Length: 'Package Length',
            Width: 'Package Width',
            Height: 'Package Height',
            Weight: 'Package Weight',
            quotationStatus: 'Quotation Status',
            Quotation: 'Quotation',
            check: 'Dimension Check',
            filled: 'Dimension Filled',
            amount: 'Quotation Amount',
            Quotenot: 'Quote not confirmed',
            not: 'Dimensions not filled',
            refuse: 'refuse',
            agree: 'agree',
            change: 'If you refuse the quotation, please change the shipping method to Customer Manual Booking',
        }
    },
};
